import React, { useEffect } from 'react';
import { NavBar, Footer } from '../../components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const callouts1 = [
    {
      name: 'Summer Collar Shirt',
      description: '$55',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p1.png',
      imageAlt: 'suspiciousAntwerp_1',
      urlTag: '/women/clothing/tops/nike4',
      id: 'collection1'
    },
    {
      name: 'Jeans Shorts',
      description: '$45',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p2.png',
      imageAlt: 'suspiciousAntwerp_2',
      urlTag: '/women/clothing/bottoms/zara4',
      id: 'collection1'
    },
    {
      name: 'Summer Loose Shirt',
      description: '$45',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p3.png',
      imageAlt: 'suspiciousAntwerp_3',
      urlTag: '/men/clothing/tops/nike3/',
    },
    {
      name: 'Collar Shirt',
      description: '$55',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p4.png',
      imageAlt: 'suspiciousAntwerp_1',
      urlTag: '/men/clothing/tops/nike6/',
      id: 'collection1'
    },
    {
      name: 'Men Pants',
      description: '$45',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p5.png',
      imageAlt: 'suspiciousAntwerp_2',
      urlTag: '/men/clothing/bottoms/zara2/',
      id: 'collection1'
    },
    {
      name: 'Cotton Tee',
      description: '$45',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p6.png',
      imageAlt: 'suspiciousAntwerp_3',
      urlTag: '/women/clothing/tops/nike1',
    },
    {
      name: 'Loose Jacket',
      description: '$45',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p7.png',
      imageAlt: 'suspiciousAntwerp_1',
      urlTag: '/women/clothing/tops/nike5',
      id: 'collection1'
    },
    {
      name: 'Men Polo',
      description: '$55',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p8.png',
      imageAlt: 'suspiciousAntwerp_2',
      urlTag: '/men/clothing/tops/nike2',
      id: 'collection1'
    },
    {
      name: 'Cotton Skirt',
      description: '$30',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p9.png',
      imageAlt: 'suspiciousAntwerp_3',
      urlTag: '/women/clothing/bottoms/zara1',
    },
  ];

const callouts2 = [
    {
      name: 'T Shirt',
      description: '$55',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p1.png',
      imageAlt: 'suspiciousAntwerp_1',
      urlTag: '/men/clothing/tops/nike5',
      id: 'collection2'
    },
    {
      name: 'Navi Jeans',
      description: '$30',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p2.png',
      imageAlt: 'suspiciousAntwerp_2',
      urlTag: '/men/clothing/bottoms/zara1',
      id: 'collection2'
    },
    {
      name: 'Loose Pants',
      description: '$45',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p3.png',
      imageAlt: 'suspiciousAntwerp_3',
      urlTag: '/women/clothing/bottoms/zara2',
    },
    {
      name: 'Summer Skirt',
      description: '$45',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p4.png',
      imageAlt: 'suspiciousAntwerp_1',
      urlTag: '/women/clothing/bottoms/zara3',
      id: 'collection2'
    },
    {
      name: 'Nike Sportswear Premium Essentials',
      description: '$45',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p5.png',
      imageAlt: 'suspiciousAntwerp_2',
      urlTag: '/men/clothing/tops/nike1',
      id: 'collection2'
    },
    {
      name: 'Summer Dress',
      description: '$55',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p6.png',
      imageAlt: 'suspiciousAntwerp_3',
      urlTag: '/women/clothing/tops/nike2',
    },
    {
      name: 'Logo T Shirt',
      description: '$55',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p7.png',
      imageAlt: 'suspiciousAntwerp_1',
      urlTag: '/men/clothing/tops/nike7',
      id: 'collection2'
    },
    {
      name: 'ACG Jacket',
      description: '$55',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p8.png',
      imageAlt: 'suspiciousAntwerp_2',
      urlTag: '/men/clothing/tops/nike4',
      id: 'collection2'
    },
    {
      name: 'Cotton Tank Top',
      description: '445',
      imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p9.png',
      imageAlt: 'suspiciousAntwerp_3',
      urlTag: '/women/clothing/tops/nike3',
    },
  ];

const MenClothing = () => {
  const { t } = useTranslation();
  // Hash scrolling functionality
  useEffect(() => {
    const scrollToSection = () => {
      const hash = window.location.hash.substring(1); // Remove the '#' character
      if (hash) {
        const element = document.getElementById(hash);
        if (element) {
          // Add a small delay to ensure the page has rendered
          setTimeout(() => {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }, 100);
        }
      }
    };

    // Scroll on initial load
    scrollToSection();

    // Listen for hash changes (when user clicks browser back/forward or manually changes hash)
    const handleHashChange = () => {
      scrollToSection();
    };

    window.addEventListener('hashchange', handleHashChange);

    // Cleanup event listener
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // stagger motion animation
  const containerMotion = {
    visible: { transition: { staggerChildren: 0.2 } },
  };

  // animation parameters for TEXT
  const headerMotion = {
    // movement = FADE-IN + UPWARDS movement
    hidden: { opacity: 0, y: 50 }, // INITIAL STAGE
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeInOut' }}, // ANIMATION STAGE
  };

  // animation parameters for TEXT
  const textMotion = {
    // movement = FADE-IN + UPWARDS movement
    hidden: { opacity: 0, y: -50 }, // INITIAL STAGE
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeInOut' }}, // ANIMATION STAGE
  };

  // animation parameters for IMAGE
  const imageMotion = {
    // movement = FADE-IN + SLIDE DOWN
    hidden: { opacity: 0 }, // INITIAL STAGE
    visible: { opacity: 1, transition: { duration: 0.5, ease: 'easeInOut' } }, // ANIMATION STAGE
  };

  return (
    <div className="bg-white">
      {/* NAVIGATION BAR */}
      <NavBar />

      {/* HEADER SECION */}
      <div className="bg-contain bg-center bg-no-repeat bg-[url('https://storage.googleapis.com/esenca-static-hosting/demo-shop/static/collections.png')]">
        <div className="pt-44 sm:pt-30 lg:pt-54">
            {/* HEADING TEXT */}
            <motion.div className="mx-auto sm:max-w-lg"
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.5}}
                variants={containerMotion}
                >
                <motion.h1 className="flex justify-center text-center text-5xl lg:text-6xl font-semibold tracking-tight text-gray-700 mt-60 sm:mt-56 lg:mt-21" variants={headerMotion} style={{"visibility": "hidden"}}>
                    {t("Craft Your")}
                </motion.h1>
                <motion.h1 className="flex justify-center text-center text-5xl lg:text-6xl font-semibold tracking-tight text-transparent bg-clip-text bg-gradient-to-l from-blue-500 to-purple-500" variants={headerMotion} style={{"visibility": "hidden"}}>
                    {t("Signature Look")}
                </motion.h1>
                <motion.h1 className="flex justify-center text-center text-2xl lg:text-3xl font-semibold tracking-tight text-gray-700 mt-4" variants={headerMotion} style={{"visibility": "hidden"}}>
                    {t("Style Your Game with Confidence.")}
                </motion.h1>
            </motion.div>
        </div>
      </div>

      {/* Collections - Grid View */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-16 mb-16">
        <motion.div className="mx-auto max-w-2xl py-16 sm:py-24 lg:max-w-none lg:py-10"
            // initial="hidden"
            whileInView="visible"
            viewport={{once: true, amount: 0.2}}
            variants={containerMotion}
            >
          {/* SECTION TEXT */}
          <div className='flex justify-center' id='collection1'>
            <motion.h2 className="text-4xl font-bold text-gray-900 mr-1.5" variants={textMotion}>
              {t("Discover")}
            </motion.h2>
            <motion.h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-l mr-1.5" style={{color: '#EA6A5E'}} variants={textMotion}>
              {t("Summer Essentials")}
            </motion.h2>
          </div>

          {/* REUSABLE TEMPlATE FORMAT */}
          <div className="mt-12 space-y-12 lg:grid sm:grid-cols-3 lg:grid-cols-3 lg:gap-x-6 lg:space-y-0 lg:gap-y-16">
            {callouts1.map((callout) => (
              <div key={callout.name} className="group relative">
                
                {/* Collection Image */}
                <motion.div className="relative h-80 w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 shadow-xl transition-transform duration-300 transform group-hover:scale-95 sm:h-64" variants={imageMotion}>
                  <Link to={callout.urlTag}>
                    <img
                      src={callout.imageSrc}
                      alt={callout.imageAlt}
                      className="h-full w-full object-cover object-center group-hover:opacity-80"
                    />
                  </Link>
                </motion.div>

                {/* TEXT SECTION */}
                <motion.span variants={textMotion}>
                  {/* Collection Title */}
                  <h3 className="mt-6 text-1xl font-none text-[#EA6A5E]">
                    <a href={callout.href}>
                      {t(callout.name)}
                    </a>
                  </h3>

                  {/* Collection Description */}
                  <p className="text-base font-semibold text-[#291A1A]">
                    {t(callout.description)}
                  </p>
                </motion.span>

              </div>
            ))}
          </div>

          {/* SECTION TEXT */}
          <div className='flex justify-center mt-36' id='collection2'>
            <motion.h2 className="text-4xl font-bold text-gray-900 mr-1.5" variants={textMotion}>
              {t("Discover")}
            </motion.h2>
            <motion.h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-l mr-1.5" style={{color: '#EA6A5E'}} variants={textMotion}>
              {t("Autumn Essentials")}
            </motion.h2>
          </div>

          {/* REUSABLE TEMPlATE FORMAT */}
          <div className="mt-12 space-y-12 lg:grid sm:grid-cols-3 lg:grid-cols-3 lg:gap-x-6 lg:space-y-0 lg:gap-y-16">
            {callouts2.map((callout) => (
              <div key={callout.name} className="group relative">
                
                {/* Collection Image */}
                <motion.div className="relative h-80 w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 shadow-xl transition-transform duration-300 transform group-hover:scale-95 sm:h-64" variants={imageMotion}>
                  <Link to={callout.urlTag}>
                    <img
                      src={callout.imageSrc}
                      alt={callout.imageAlt}
                      className="h-full w-full object-cover object-center group-hover:opacity-80"
                    />
                  </Link>
                </motion.div>

                {/* TEXT SECTION */}
                <motion.span variants={textMotion}>
                  {/* Collection Title */}
                  <h3 className="mt-6 text-1xl font-none text-[#EA6A5E]">
                    <a href={callout.href}>
                      {t(callout.name)}
                    </a>
                  </h3>

                  {/* Collection Description */}
                  <p className="text-base font-semibold text-[#291A1A]">
                    {t(callout.description)}
                  </p>
                </motion.span>

              </div>
            ))}
          </div>

        </motion.div>
      </div>

      {/* NAVIGATION BAR */}
      <Footer/>
    </div>
  )
}

export default MenClothing